import * as Yup from 'yup';

export const loginValidationScheme = Yup.object({
  email: Yup.string().email().required('This field is required'),
  password: Yup.string().required('This field is required'),
});
